/* SUREFIRE YOUTH — interactive brush recommendation quiz */
(function () {
  'use strict';

  if (customElements.get('sfy-brush-quiz')) return;

  var pairCopy = {
    '000-001': 'Detangle and prepare first, then move into focused pattern work.',
    '000-002': 'Prepare with the Wolf Whisperer, then continue with the Daily Driver.',
    '000-003': 'Reset and organize first, then move into a softer lay-and-shine pass.',
    '000-004': 'Start with detangling prep, then finish with the gentlest pass.',
    '001-002': 'Use The Zamboo for focused pattern sessions and Medium Soft for everyday work.',
    '001-003': 'Train with true-medium pull, then soften, lay and add shine.',
    '001-004': 'Train the pattern first, then finish with an extra-soft pass.',
    '002-003': 'Use Medium Soft for daily brushing, then bring in the Softy for lay and shine.',
    '002-004': 'Use Medium Soft as the Daily Driver and the Unicorn as the finisher.',
    '003-004': 'Use the Softy for lay and grab, then finish extra-soft with the Unicorn.'
  };

  function SFYBrushQuiz() {
    return Reflect.construct(HTMLElement, [], SFYBrushQuiz);
  }

  SFYBrushQuiz.prototype = Object.create(HTMLElement.prototype);
  SFYBrushQuiz.prototype.constructor = SFYBrushQuiz;
  Object.setPrototypeOf(SFYBrushQuiz, HTMLElement);

  SFYBrushQuiz.prototype.connectedCallback = function () {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.currentQuestion = 0;
    this.screens = {
      intro: this.querySelector('[data-quiz-screen="intro"]'),
      questions: this.querySelector('[data-quiz-screen="questions"]'),
      result: this.querySelector('[data-quiz-screen="result"]')
    };
    this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-question]'));
    this.resultCards = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-result-card]'));
    this.startButton = this.querySelector('[data-quiz-start]');
    this.backButton = this.querySelector('[data-quiz-back]');
    this.nextButton = this.querySelector('[data-quiz-next]');
    this.restartButton = this.querySelector('[data-quiz-restart]');
    this.progress = this.querySelector('[data-quiz-progress]');
    this.progressFill = this.querySelector('[data-quiz-progress-fill]');
    this.stepLabel = this.querySelector('[data-quiz-step-label]');
    this.resultHeading = this.querySelector('[data-quiz-result-heading]');
    this.resultIntro = this.querySelector('[data-quiz-result-intro]');
    this.routine = this.querySelector('[data-quiz-routine]');

    if (!this.panels.length || !this.startButton || !this.nextButton) return;

    this.startButton.addEventListener('click', this.start.bind(this));
    this.backButton.addEventListener('click', this.goBack.bind(this));
    this.nextButton.addEventListener('click', this.goNext.bind(this));
    this.restartButton.addEventListener('click', this.restart.bind(this));

    this.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) this.updateControls();
    }.bind(this));
  };

  SFYBrushQuiz.prototype.showScreen = function (name) {
    Object.keys(this.screens).forEach(function (key) {
      this.screens[key].hidden = key !== name;
    }.bind(this));
  };

  SFYBrushQuiz.prototype.scrollIntoViewIfNeeded = function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = this.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.35) {
      this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  };

  SFYBrushQuiz.prototype.start = function () {
    this.currentQuestion = 0;
    this.showScreen('questions');
    this.renderQuestion();
    this.scrollIntoViewIfNeeded();
    var firstInput = this.panels[0].querySelector('input');
    if (firstInput) window.setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 120);
  };

  SFYBrushQuiz.prototype.renderQuestion = function () {
    this.panels.forEach(function (panel, index) {
      panel.hidden = index !== this.currentQuestion;
    }.bind(this));

    var humanStep = this.currentQuestion + 1;
    var total = this.panels.length;
    this.stepLabel.textContent = 'Question ' + humanStep + ' of ' + total;
    this.progress.setAttribute('aria-valuenow', String(humanStep));
    this.progressFill.style.width = ((humanStep / total) * 100) + '%';
    this.nextButton.textContent = humanStep === total ? 'See my match' : 'Next';
    this.updateControls();
  };

  SFYBrushQuiz.prototype.selectedForCurrent = function () {
    return this.panels[this.currentQuestion].querySelector('input[type="radio"]:checked');
  };

  SFYBrushQuiz.prototype.updateControls = function () {
    this.nextButton.disabled = !this.selectedForCurrent();
  };

  SFYBrushQuiz.prototype.goBack = function () {
    if (this.currentQuestion === 0) {
      this.showScreen('intro');
      this.startButton.focus({ preventScroll: true });
      return;
    }
    this.currentQuestion -= 1;
    this.renderQuestion();
    var selected = this.selectedForCurrent();
    if (selected) selected.focus({ preventScroll: true });
  };

  SFYBrushQuiz.prototype.goNext = function () {
    if (!this.selectedForCurrent()) return;
    if (this.currentQuestion < this.panels.length - 1) {
      this.currentQuestion += 1;
      this.renderQuestion();
      var selected = this.selectedForCurrent();
      var target = selected || this.panels[this.currentQuestion].querySelector('input');
      if (target) target.focus({ preventScroll: true });
      return;
    }
    this.complete();
  };

  SFYBrushQuiz.prototype.getAnswers = function () {
    return this.panels.map(function (panel) {
      var chosen = panel.querySelector('input[type="radio"]:checked');
      return chosen ? chosen.value : null;
    }).filter(Boolean);
  };

  SFYBrushQuiz.prototype.getWinningCodes = function (answers) {
    var counts = { '000': 0, '001': 0, '002': 0, '003': 0, '004': 0 };
    answers.forEach(function (answer) { counts[answer] += 1; });
    var maximum = Math.max.apply(null, Object.keys(counts).map(function (code) { return counts[code]; }));
    var tied = Object.keys(counts).filter(function (code) { return counts[code] === maximum; });
    if (tied.length === 1) return tied;

    // Goal and routine-position answers break broad ties because they say the
    // most about what the customer needs the brush to do.
    var priority = [answers[0], answers[2], answers[1], answers[3]];
    var selected = [];
    priority.forEach(function (code) {
      if (tied.indexOf(code) !== -1 && selected.indexOf(code) === -1 && selected.length < 2) selected.push(code);
    });
    tied.forEach(function (code) {
      if (selected.indexOf(code) === -1 && selected.length < 2) selected.push(code);
    });
    return selected.sort();
  };

  SFYBrushQuiz.prototype.complete = function () {
    var answers = this.getAnswers();
    var codes = this.getWinningCodes(answers);
    var isPair = codes.length > 1;

    this.resultCards.forEach(function (card) {
      card.hidden = codes.indexOf(card.dataset.quizResultCard) === -1;
    });

    this.resultHeading.textContent = isPair ? 'Your two-brush routine.' : 'Your best match.';
    this.resultIntro.textContent = isPair
      ? 'Your answers split across two important parts of the process. That is not a tie—it is a smarter rotation.'
      : 'Your answers point to one brush that fits the way you like to work.';

    if (isPair) {
      this.routine.textContent = pairCopy[codes.join('-')] || 'Use the first brush for your main need, then bring in the second for the next stage of the routine.';
      this.routine.hidden = false;
    } else {
      this.routine.hidden = true;
      this.routine.textContent = '';
    }

    this.showScreen('result');
    this.scrollIntoViewIfNeeded();
    this.resultHeading.setAttribute('tabindex', '-1');
    this.resultHeading.focus({ preventScroll: true });

    document.dispatchEvent(new CustomEvent('sfy:quiz-complete', {
      detail: { answers: answers, codes: codes }
    }));
  };

  SFYBrushQuiz.prototype.restart = function () {
    this.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
    this.currentQuestion = 0;
    this.showScreen('intro');
    this.renderQuestion();
    this.scrollIntoViewIfNeeded();
    this.startButton.focus({ preventScroll: true });
  };

  customElements.define('sfy-brush-quiz', SFYBrushQuiz);
})();
